import { render, staticRenderFns } from "./ScopeOfWork.vue?vue&type=template&id=1eedbec3&scoped=true&"
import script from "./ScopeOfWork.vue?vue&type=script&lang=js&"
export * from "./ScopeOfWork.vue?vue&type=script&lang=js&"
import style0 from "./ScopeOfWork.vue?vue&type=style&index=0&id=1eedbec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eedbec3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eedbec3')) {
      api.createRecord('1eedbec3', component.options)
    } else {
      api.reload('1eedbec3', component.options)
    }
    module.hot.accept("./ScopeOfWork.vue?vue&type=template&id=1eedbec3&scoped=true&", function () {
      api.rerender('1eedbec3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/view/ScopeOfWork.vue"
export default component.exports